import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Chats from '../components/Chats';

const ChatPage = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact path={ `${match.url}/:chatId?` }>
        <Chats />
      </Route>
    </Switch>
  )
};

export default ChatPage;
